import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const recruitmentPolicyAPI = createApi({
    reducerPath: 'recruitmentPolicyAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        fetchRecruitmentPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.FETCH_RECRUITMENT_POLICY,
                method: 'POST',
                data,
            }),
        }),
        resyncAllPositionsWithAllPolicies: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.RESYNC_ALL_POSITIONS_WITH_ALL_POLICIES,
                method: 'POST',
                data,
            }),
        }),
        resyncSingleRecruitmentPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.RESYNC_SINGLE_RECRUITMENT_POLICY,
                method: 'POST',
                data,
            }),
        }),
        saveRulesForRecruitmentPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SAVE_RULES_FOR_RECRUITMENT_POLICY,
                method: 'POST',
                data,
            }),
        }),
        deleteRulesForRecruitmentPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_RULES_FOR_RECRUITMENT_POLICY,
                method: 'POST',
                data,
            }),
        }),
        preCreateRulesForRecruitmentPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_CREATE_RULES_FOR_RECRUITMENT_POLICY,
                method: 'POST',
                data,
            }),
        }),
        preCreateRuleSettingsForRecruitmentPolicy: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.PRE_CREATE_RULE_SETTINGS_FOR_RECRUITMENT_POLICY,
                method: 'POST',
            }),
        }),
        saveRuleSettingForRecruitmentPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SAVE_RULE_SETTING_FOR_RECRUITMENT_POLICY,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useFetchRecruitmentPolicyMutation,
    useResyncAllPositionsWithAllPoliciesMutation,
    useResyncSingleRecruitmentPolicyMutation,
    useSaveRulesForRecruitmentPolicyMutation,
    useDeleteRulesForRecruitmentPolicyMutation,
    usePreCreateRulesForRecruitmentPolicyMutation,
    usePreCreateRuleSettingsForRecruitmentPolicyMutation,
    useSaveRuleSettingForRecruitmentPolicyMutation,
} = recruitmentPolicyAPI;
